module.exports = __webpack_public_path__ + "media/images/wpp-ebd393f9b2c220800c504140c70d0ece.png";